"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ImageSwatch: function() {
        return _index.ImageSwatch;
    },
    imageSwatchClassNames: function() {
        return _index.imageSwatchClassNames;
    },
    renderImageSwatch_unstable: function() {
        return _index.renderImageSwatch_unstable;
    },
    useImageSwatchStyles_unstable: function() {
        return _index.useImageSwatchStyles_unstable;
    },
    useImageSwatch_unstable: function() {
        return _index.useImageSwatch_unstable;
    }
});
const _index = require("./components/ImageSwatch/index");
